/**
 * ThemeProbePublic — auth-free wrapper around the existing ThemeProbe so
 * the CI smoke runner (headless Chromium → screenshot → pixel-diff) can
 * hit a fixed URL without needing a session token.
 *
 * Renders nothing business-sensitive: only primitive components shown in
 * forced light + forced dark panes, side by side. Mounted at /__theme-probe.
 */
import React from 'react';
import ThemeProbe from '@/pages/dashboard/ThemeProbe';

export default function ThemeProbePublic() {
  return (
    <div data-testid="theme-probe-public">
      <ThemeProbe />
    </div>
  );
}
